<div
  [ngStyle]="{ width: size, height: size, position: position }"
  class="spinner-circle"
>
  <div
    *ngFor="let i of elements"
    class="spinner-circle-{{ i }} spinner-child"
  ></div>
</div>
